import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { login as loginApi, getUserInfo } from '@/api/login'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: getToken(),
    adminInfo: null
  },
  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
      setToken(token)
    },
    REMOVE_TOKEN (state) {
      state.token = ''
      removeToken()
    },
    SET_INFO (state, info) {
      state.adminInfo = info
    }
  },
  actions: {
    login ({ commit }, payload) {
      return loginApi(payload).then(data => {
        commit('SET_TOKEN', data.token)
        return data
      })
    },
    logout ({ commit }) {
      commit('REMOVE_TOKEN')
      commit('SET_INFO', null)
    },
    getInfo ({ commit, state }) {
      if (state.adminInfo) {
        return Promise.resolve(state.adminInfo)
      }
      return getUserInfo().then(data => {
        commit('SET_INFO', data)
        return data
      })
    }
  },
  getters: {
    token: state => state.token,
    adminInfo: state => state.adminInfo,
    username: state => (state.adminInfo && state.adminInfo.username) || '',
    nickname: state => (state.adminInfo && state.adminInfo.nickname) || '',
    avatar: state => (state.adminInfo && state.adminInfo.avatar) || ''
  }
})

export default store
